import angular from 'angular';
class VideoProviderResolver {
    constructor($injector, $rootScope, $stateParams, $location, Room) {
        this.$injector = $injector;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Room = Room;
        this.availableProviders = {
            tokbox: 'Tokbox',
        };
        this.waitForName = new Promise((resolve) => {
            const videoChatProviderParam = $stateParams.vcp || $location.search().vcp;
            if (Object.keys(this.availableProviders).includes(videoChatProviderParam)) {
                return resolve(videoChatProviderParam);
            }
            else {
                return resolve('tokbox');
                /*$rootScope.$once('currentRoomResolved', ($e, room) => {
                  Room.prototype$getVideoProvider({
                    id: room.id,
                    $_clearAuthorization: true
                  })
                    .$promise.then((res: { provider: VideoProviderName }) => {
                      resolve(res.provider || 'tokbox');
                    })
                    .catch(() => {
                      resolve('tokbox');
                    });
                });*/
            }
        });
    }
    waitForProviderName() {
        return this.waitForName;
    }
    getProviderService(name) {
        return this.$injector.get(`${this.availableProviders[name]}VideoProvider`);
    }
    waitForProvider() {
        return this.waitForProviderName().then((name) => {
            return this.getProviderService(name);
        });
    }
}
export { VideoProviderResolver };
export default angular
    .module('doxy.providers.video.common.services.videoProviderResolver', [])
    .service('VideoProviderResolver', VideoProviderResolver).name;
